import { dateToFormat } from 'helpers/formatters/date';
import {
  AssetWeightedLineItem,
  AssetWeightedTimeWindow,
} from 'types/AssetWeighted';
import { formatToDate } from 'helpers/date';

export type RowType = {
  fromDate: string;
  assetSelectionSet: string;
};

export const getRowFormatted = (row: any) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      assetSelectionSet: row.returnComponent,
      isTimeWindowEnable: true,
    },
  };
};

export const useTable = (
  data: Array<AssetWeightedTimeWindow> = [],
  onDeleteRow?: (fromDate: string) => void
) => {
  const columns = [
    {
      Header: 'From Date',
      accessor: 'fromDate',
    },
    {
      Header: 'To Date',
      accessor: 'toDate',
    },
    {
      Header: 'Assets',
      accessor: 'assets',
      Cell: (row: any) => (
        <div style={{ whiteSpace: 'pre-line' }}>{row.value}</div>
      ),
    },
  ];

  const actionDeleteRow = (onCloseModal: any, row: any) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  return {
    data: data?.map((item: any) => ({
      ...item,
      fromDate: dateToFormat(new Date(item.fromDate), 'MM/dd/y'),
      toDate: formatToDate(item.fromDate, item.toDate),
      assets: item.lineItems
        ?.map((lineItem: AssetWeightedLineItem) => lineItem.weightingComponentName)
        ?.join('\n'),
    })),
    columns,
    actionDeleteRow,
  };
};
